module.exports = __webpack_public_path__ + "static/media/promo-winter-mobile.608ea81f.png";